<template>
  <v-card class="flex px-6 py-5 justify-center align-center step-card" :class="{ 'step-card-suggested': suggested }"
    elevation="0" @click="$emit('click', $event)">
    <div>
      <component
        :is="icon"
        v-if="!completed && isCustomIcon"
        :color="suggested ? 'plusIndigoLighten1' : iconColor"
        size="24px"
      />
      <v-icon v-else-if="!completed" size="24" :color="suggested ? 'plusIndigoLighten1' : iconColor">{{ icon }}</v-icon>
      <v-icon v-if="completed" size="24" color="plusTealLighten1">mdi-check-circle</v-icon>
    </div>
    <div class="flex" style="gap:0.625rem">
      <div class="flex flex-col">
        
        <div v-if="showSuggestedLabel" class="plusIndigoLighten1--text text-uppercase font-weight-semibold"
          style="font-size:0.625rem">{{ $t("message.onboard_suggested_step") }}</div>
        
          <div class="flex flex-col justify-center" :class="{ 'text-decoration-line-through': completed }">
          <div v-if="title">{{ title }}</div>
          <div v-if="description" class="step-card-description plusTextSecondary--text">{{ description }}</div>
        </div>
      </div>
      <div v-if="suggested || showChevron" class="flex justify-end align-center">
        <div class="step-card-chevron flex justify-center align-center rounded-circle"
          :class="suggested ? 'plusIndigoLighten1' : 'tour-chevron'">
          <v-icon size="16" color="white">mdi-chevron-right</v-icon>
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  props: {
    icon: {
      type: [String, Object, Function],
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    suggested: {
      type: Boolean
    },
    showSuggestedLabel: {
      type: Boolean,
      default: false
    },
    completed: {
      type: Boolean
    },
    iconColor: {
      type: String,
      default: 'plusTextSecondary'
    },
    showChevron: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isCustomIcon() {
      return typeof this.icon !== "string" || !this.icon.startsWith("mdi-");
    }
  }
}
</script>
<style scoped>
.step-card {
  gap: 0.5rem;
  font-size: 0.938rem;
  cursor: pointer;
  border: 1px solid var(--v-plusBorder-base);
  background-color: var(--v-plusSurface-base);
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.theme--dark.step-card {
  background-color: #2A2A2A;
  border-color: #3A3A3A;
}

.step-card-suggested {
  background-color: #F6F7FF;
  border-left: 3px solid var(--v-plusIndigoLighten1-base);
}

.theme--dark.step-card.step-card-suggested {
  background-color: rgba(92, 107, 192, 0.22);
  border: 1px solid var(--v-plusIndigoLighten1-base);
  border-left: 3px solid var(--v-plusIndigoLighten1-base);
}

.step-card-description {
  font-size: 0.938rem;
  font-weight: 500;
}

.step-card-suggested .step-card-description {
  font-size: 0.875rem;
  font-weight: 400;
}

.step-card-chevron {
  width: 2.25rem;
  height: 2.25rem;
  max-width: 2.25rem;
  max-height: 2.25rem;
  padding: 10px;
}

.tour-chevron {
  background-color: var(--v-plusTealLighten1-base);
  opacity: 0.6;
}
</style>
